<!--
*  TTTech nerve-management-system
*  Copyright(c) 2022. TTTech Industrial Automation AG.
*
*  ALL RIGHTS RESERVED.
*
*  Usage of this software, including source code, netlists, documentation,
*  is subject to restrictions and conditions of the applicable license
*  agreement with TTTech Industrial Automation AG or its affiliates.
*
*  All trademarks used are the property of their respective owners.
*
*  TTTech Industrial Automation AG and its affiliates do not assume any liability
*  arising out of the application or use of any product described or shown
*  herein. TTTech Industrial Automation AG and its affiliates reserve the right to
*  make changes, at any time, in order to improve reliability, function or
*  design.
*
*  Contact Information:
*  support@tttech-industrial.com
*
*  TTTech Industrial Automation AG, Schoenbrunnerstrasse 7, 1040 Vienna, Austria
*
*/
-->
<template>
  <div></div>
  <NerveDialog v-model="dialogState" persistent width="500" @keydown.esc="close()" @keydown.enter="confirm()">
    <v-card class="confirm-dialog">
      <v-card-title>
        {{ $t(utilsStore.apiPermissionConfirmDialogParams.title) }}
      </v-card-title>
      <v-card-text class="text-center text-grey-darken-1">
        <v-row class="justify-center" no-gutters>
          {{ $t(utilsStore.apiPermissionConfirmDialogParams.msg) }}
        </v-row>
        <v-row class="justify-center mb-3">
          <v-checkbox
            id="iiotApiPermissionConfirmDialogCheckbox"
            ref="apiPermissionDialogCheckbox"
            v-model="dontShowDialog"
            :label="$t('access.roles.roleDetails.apiPermissionsDialogCheckbox')"
          />
        </v-row>
      </v-card-text>
      <v-card-actions>
        <NerveButton
          id="iiotApiPermissionConfirmDialogCancelButton"
          ref="apiPermissionDialogCancelButton"
          :text="$t('access.roles.roleDetails.apiPermissionsCancelAction')"
          type-of-btn="cancel"
          size="normal"
          class="mr-2"
          @click-event="close"
        />
        <NerveButton
          id="iiotApiPermissionConfirmDialogConfirmButton"
          ref="apiPermissionDialogConfirmButton"
          :text="$t('access.roles.roleDetails.apiPermissionsConfirmAction')"
          type-of-btn="action"
          size="normal"
          @click-event="confirm"
        />
      </v-card-actions>
    </v-card>
  </NerveDialog>
</template>

<script setup>
import logger from '@/plugins/logger';
import { ref, computed } from 'vue';
import { NerveButton, NerveDialog } from '@nerve/ui-components';

// Store
import useRolesStore from '@/store/modules/pinia/roles';
import useUtilsStore from '@/store/modules/pinia/utils/_api_request_handler';
const rolesStore = useRolesStore();
const utilsStore = useUtilsStore();

const dontShowDialog = ref(false);

const dialogState = computed({
  get() {
    return utilsStore.apiPermissionConfirmDialog;
  },
  set() {
    close();
  },
});

async function close() {
  if (utilsStore.apiPermissionConfirmDialogParams.cancelCallback) {
    await utilsStore.apiPermissionConfirmDialogParams.cancelCallback();
  }
  utilsStore.closeApiPermissionConfirm();
}

async function confirm() {
  try {
    rolesStore.setShowConfirmationDialog(!dontShowDialog.value);
    await utilsStore.apiPermissionConfirmDialogParams.confirmCallback();
    utilsStore.closeApiPermissionConfirm();
  } catch (e) {
    logger.debug(e);
  }
}
</script>

<style scoped>
.confirm-dialog {
  max-height: 460px !important;
  min-height: 320px !important;
}
</style>
